import { Link } from "react-router-dom";
import Button from "../../components/Button";
import PromoCode from "../../components/PromoCode";

const Summary = () => {
  return (
    <div className="px-4">
      <div className="mx-4">
        <div className="title mb-4 text-lg font-medium">
          <h4>Summary</h4>
        </div>
        <div className="summary-details text-base mb-4">
          <ul>
            <li className="flex items-center justify-between">
              <span>Subtotal</span>
              <span>₺5.99</span>
            </li>
            <li className="flex items-center justify-between">
              <span>Shipping</span>
              <span>Free</span>
            </li>
            <li className="total flex justify-between border-y my-4 py-4">
              <div className="flex flex-col">
                <span>Total</span>
                <span className="text-sm text-[#8b8b8b]">(including VAT)</span>
              </div>
              <div>
                <span className="font-medium">₺1500.00</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="actions px-4">
        <div className="my-4">
          <Link to="/everyone/shop/checkout">
            <Button
              backgroundColor={"bg-white"}
              font={"text-black text-[15px] font-normal"}
              border="border-2 border-[#e46552]"
              isHovered
              hover={"hover:text-[#e46552]"}
              width="w-full"
            >
              Pay as a Guest
            </Button>
          </Link>
        </div>
        <div className="my-4">
          <Link to="/everyone/shop/checkout">
            <Button isHovered width={"w-full"}>
              Pay by Signing In
            </Button>
          </Link>
        </div>
      </div>
      <div className="promo-code px-4">
        <PromoCode />
      </div>
    </div>
  );
};

export default Summary;
